import React, { useCallback } from 'react'

import TextButton from 'LuxKit/Button/TextButton'
import FooterWithCreateUpdateInfo from 'tripPlanner/components/TripModal/Common/FooterWithCreateUpdateInfo'
import useModalCallbacks from 'tripPlanner/hooks/View/useModalCallbacks'
import type { TripItem } from 'tripPlanner/types/tripItem'

interface Props {
  item: TripItem
}

export default function ReadOnlyItemFooter({ item }: Props) {
  const { closeModal } = useModalCallbacks()

  const onClose = useCallback(() => {
    closeModal()
  }, [closeModal])

  return (
    <FooterWithCreateUpdateInfo item={item}>
      <TextButton size="large" kind="primary" onClick={onClose}>
        Done
      </TextButton>
    </FooterWithCreateUpdateInfo>
  )
}
